import { z } from 'zod';

import { CookingComfortEnum, DietaryIdentityEnum } from './diet-preferences.js';
import { MealTypeEnum } from './diet.js';

// ─── Sample-day preview shapes ────────────────────────────────────────────

/** One slot of an archetype sample day — meal slot + 2-6 illustrative foods. */
export const DietArchetypeSlotPreviewV1Schema = z.object({
  mealType: MealTypeEnum,
  sampleFoods: z.array(z.string().min(1).max(80)).min(2).max(6),
});
export type DietArchetypeSlotPreviewV1 = z.infer<typeof DietArchetypeSlotPreviewV1Schema>;

/** Full 4-slot sample-day outline; rendered in the recommendation card preview. */
export const DietArchetypeSampleDayV1Schema = z.object({
  version: z.literal('v1'),
  slots: z.array(DietArchetypeSlotPreviewV1Schema).length(4),
});
export type DietArchetypeSampleDayV1 = z.infer<typeof DietArchetypeSampleDayV1Schema>;

// ─── DietArchetype (catalog row, post-load) ───────────────────────────────

/** Catalog row shape for DietArchetype — validates seeds + recommendation inputs. */
export const DietArchetypeV1Schema = z.object({
  version: z.literal('v1'),
  id: z.string().min(1).max(80),
  name: z.string().min(1).max(120),
  vibe: z.string().min(1).max(200),
  description: z.string().min(1).max(500),
  dietaryIdentityFilter: z.array(DietaryIdentityEnum).min(1),
  minCookingComfort: CookingComfortEnum,
  assumesWhey: z.boolean(),
  approxDailyCostInr: z.number().int().min(0).max(2000),
  sampleSlots: DietArchetypeSampleDayV1Schema,
});
export type DietArchetypeV1 = z.infer<typeof DietArchetypeV1Schema>;
